<template>
        <div class="bg-wrap">
            <div class="kv">
            </div>
             <div class="content-wrap">
                    <span class="title">{{title}}</span>
                    <span class="a">竞答题</span>
                    <label class="b l" @click="toHostStart(type)" v-if="state==0">第{{order}}题，开题</label>
                    <label class="b s" v-if="this.state==1">第{{order}}题，抢题中</label>
                    <label class="b s" v-if="this.state==2">第{{order}}题，答题中</label>
                    <label class="b s" v-if="this.questionId==-1">竞答结束</label>
                    <span class="c">{{hint}}</span>
                    <div class="players">
                        <div class="item" v-for="(value,index) in players" v-bind:key="index">
                            <img :src="value.avatar!=null?value.avatar :getHead()" :class="value.king==1?'light':'shadow'" @click="toHostCheck(value,questionId)">
                            <span>{{value.name}}</span>
                        </div>
                    </div>
             </div>
        </div>
</template>

<script>
    import {getPlayer,valuableQuestion,hostStart} from "../../assets/js/api";

    export default {
        inject: ["reload"], //注入reload方法
        data(){
            return{
                title:"共话新知",
                hint:"（每题2分，共5道题目，答题时间一分钟）",
                players:[],
                playerId: this.$store.state.playerId,
                type:2,
                order:0,
                questionId:0,
                host:1,
                state:0,
            }
        },
        methods:{
            toHostCheck(value,questionId){
              console.log(questionId)

              if(value.king==1){
                  this.$router.push({path:"/hostCheck",query:{questionId:questionId,playerId:value.player_id}})
              }

            },
            async toGetPlayer(questionId){
                const res = await getPlayer({questionId});
                console.log(res,"players==")
                this.players = res.data.data
            },
            async toGetValuableCompQuestion(type){

                const res = await valuableQuestion({type})
                console.log(res,"res===")
                if(res.data.success){
                    this.order = res.data.data.order
                    this.questionId = res.data.data.questionId
                    this.state = res.data.data.state
                    if(this.state!=-1){
                        //获取选手
                        this.toGetPlayer(this.questionId)
                    }
                }
            },
            async toHostStart(type){
                const res = await hostStart({type})
                if(res.data.success){
                    this.$toast("开题成功")
                }
                console.log(res,"主持人开题结果---")
            },
            getHead(){
                    return require("@/assets/img/head.png");
            },
            initWebSocket: function () {
                this.websock = new WebSocket("ws://server.iumed.com.cn/plus/one/websocket");
                // this.websock = new WebSocket("ws://192.168.31.230:9090/one/websocket");
                this.websock.onopen = this.websocketonopen;
                this.websock.onerror = this.websocketonerror;
                this.websock.onmessage = this.websocketonmessage;
                this.websock.onclose = this.websocketclose;
                console.log("--------websocketc初始化-------")
            },
            websocketonopen: function () {
                console.log("WebSocket连接成功");
            },
            websocketonerror: function (e) {
                console.log("WebSocket连接发生错误"+e.code);
            },
            websocketonmessage: function (e) {
                console.log("----signal coming----",e)
                // this.toReload();//页面刷新
                this.loadData()
            },
            websocketclose: function (e) {
                console.log("connection closed (" + e.code + ")");
            },
            loadData(){
                this.toGetValuableCompQuestion(this.type)
            }
        },
        mounted(){
            this.initWebSocket();
            this.loadData();
        }

    }
</script>

<style scoped lang="scss">
    .bg-wrap{
        width: 100%;
        /*max-width: 375px;*/
        height: 100vh;
        background: #FFF url("../../assets/img/answer_bg.png") no-repeat;
        background-size: 100% 100%;
        margin: 0 auto;
    }
    .kv{
        width: 100%;
        height: 250px;
        background: #FFF url("../../assets/img/answer_kv.png") no-repeat;
        background-size: 100% 100%;
        margin: 0 auto;
        position: relative;
    }
    .content-wrap{
        display: flex;
        flex-flow: column;
        align-items: center;
    }
    .content-wrap .title{
        color: #FFF;
        font-size: 38px;
        font-weight: bold;
        font-style: italic;
        letter-spacing: 3px;
    }

    .a{
        color: #FFF;
        font-size: 25px;
        margin-top: 10px;
        opacity: 0.8;
    }
    .b{
        color: #FFF;
        margin-top: 10px;
        font-size: 14px;
        width: 85%;
        height: 32px;
        line-height: 32px;
        border-radius: 15px;
        display: block;

    }
    .c{
        margin-top: 10px;
        color: #FFF;
        font-size: 15px;
        opacity: 0.8;
    }
    .players{
        width: 100%;
        height: 80px;
        margin-top: 30px;
        display: flex;
        flex-flow: row wrap;
        justify-content: space-around;
        align-items: center;
        color: #FFF;
        font-size: 22px;
        img{
            width: 60px;
            height: 60px;
            border-radius: 50%;
        }
        .item{
            display: flex;
            flex-direction: column;
            justify-content: center;
            margin-right: 5px;
        }
    }
    .light{
        border: 3px yellow solid;
        opacity: 1;
    }
    .shadow{
        opacity: 0.8;
    }

    .s{
        background: #999;
    }

    .l{
        background: #036eb7;
    }




</style>